//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import common from '../../api/common'
export default {
    data(){
        return {
            times:common,
            appointmentRegisterList:[],
            resgisteredList: [],
            pagination: 1,
            total: 1,
            noDataText: '',
            registrationType:1
            
        }
    },
    created(){
        document.title = '挂号';
        this.$isLogin(window.location.search.substr(1),this.init);
    },
    methods: {
        onItemClick(index){
            this.registrationType=index;
            this.refresh();
        },
        appointmentRegister(done){
            let data = {
                pagination:1,
                condition:{
                    parameters:this.$store.state.userInfo.id
                }
            }
            let _this=this;
            this.$doRequest("/api/AppointmentRegister/mybookingregisters",data,res=>{
                _this.appointmentRegisterList=res.parameters.rows;
                if(typeof(done) == 'function'){
                    done();
                }
            })
        },
        routerToDetails(datas,index){
            this.$router.push({path: '/myRegisteredDetails',query: {data:datas,types:index}});
        },
        init(){
            this.refresh();
        },
        query(done){
            var data = {
                pagination: 1,
                condition: {
                    parameters: this.$store.state.userInfo.id
                }
            } 
            this.$doRequest('/api/diagnosisqueue/queryPatientRegistration',data,res=>{
                for(var i=0;i<res.parameters.rows.length;i++){
                    var time = res.parameters.rows[i].paymenttime;
                    res.parameters.rows[i].paymenttime = common.timestampToTime(time,2);
                    res.parameters.rows[i].paymenttimes = common.timestampToTime(time,1);
                    res.parameters.rows[i].createtime = common.timestampToTime(res.parameters.rows[i].createtime,1);
                }
                this.resgisteredList = res.parameters.rows;
                this.total = res.parameters.total;
                if(typeof(done) == 'function'){
                    done();
                }
            })
        },
        refresh(done){
            if(this.registrationType==1){

                setTimeout(()=>{
                    this.pagination = 1;
                    this.appointmentRegister(done);
                },1500)
            }else{

                setTimeout(()=>{
                    this.pagination = 1;
                    this.query(done);
                },1500)
            }
        },
        infinite(done){
            this.pagination++;
            if(this.registrationType==1){
                setTimeout(()=>{
                    this.$refs.my_scroller.finishInfinite(true);
                    if(this.pagination > this.total){
                        this.noDataText = '没有更多挂号信息了';
                    }else{
                        this.appointmentRegister(done);
                    }
                },1500)
            }else{
                setTimeout(()=>{
                    this.$refs.my_scroller.finishInfinite(true);
                    if(this.pagination > this.total){
                        this.noDataText = '没有更多挂号信息了';
                    }else{
                        this.query(done);
                    }
                },1500)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/myRegistered/index.vue